import React, { useEffect, useState } from 'react';
import ImagesView from './Views/ImagesView';
import { Tabs, Card, Button, Form } from 'antd';
import PageContainer from '../../../CSIComponents/PageContainer';
import {getHelper} from '@services/helpers'
import styles from '../index.module.css'
// Images
const { TabPane } = Tabs;
const Images = (props: any) => {
  const [form] = Form.useForm();
  const [viewOrEdit, setViewOrEdit] = useState(1);

  const cancelClik = () => {
    if (props.operationFlag === "add") {
      setViewOrEdit(2)
      props.setOperation('table')
    } else { //props.operationFlag=="edit"
      setViewOrEdit(1)
      props.setOperation('view')
    }
  }
  const saveAddOrEdit = () => {
    if (props.operationFlag === "add") {
      setViewOrEdit(2)
      props.setOperation('table')

    } else { //props.operationFlag=="edit"

      setViewOrEdit(1)
      props.setOperation('view')
    }
  }
  const editButton = (
    <>
      {/* <Button type="primary" htmlType="submit" onClick={editStart}>Edit</Button> */}
    </>
  )
  const cancelAndSaveButton = (
    <>
      <Button type="primary" color={'#dc3545'} style={{ background: '#dc3545', borderColor: '#dc3545' }} onClick={cancelClik}>Cancel</Button>
      <Button type="primary" onClick={saveAddOrEdit} style={{ marginLeft: '10px', }}>Save</Button>
    </>
  )
  return (
    <>
      <PageContainer>
        <Card style={{ marginTop: -15 }}>
          <Form form={form} layout="vertical">
            <Tabs tabBarExtraContent={viewOrEdit === 1 ? editButton : cancelAndSaveButton} type="card">
              <TabPane tab="Images 1">
                <ImagesView imageData={props.currentRow} className={styles.viewLeftSpace} />
              </TabPane>
              {/* {
              dataSource.length>0 && dataSource.map((item: any, i: number) => {
                return (
                  <TabPane>
                    <ImagesView currentTagData={currentTagData} />
                  </TabPane>
                    <TabPane tab={"Images " + [i + 1]} key={i} disabled={props.operationFlag == 'edit' || props.operationFlag == 'add'}>
                  
                    {viewOrEdit == 1 ? <ImagesView currentTagData={item}/> : < ImgagesEdit/>}
                  </TabPane>
                )
              })
            } */}
            </Tabs>
          </Form>
        </Card>
      </PageContainer>
    </>
  )
}


export default Images;
